import { config } from '@services/config';
import { UserGetResponse } from '@lio/api-types';
import { useOktaAuth } from '@okta/okta-react';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCurrentUser = () => {
  const { authState } = useOktaAuth();
  const isAuthenticated = !!authState?.isAuthenticated;
  const client = useClient();
  const result = useQuery({
    queryKey: userQueryKey.currentUser,
    queryFn: async () => client.get('user/current').json<UserGetResponse>(),
    refetchOnMount: (query) => query.state.status !== 'error',
    refetchOnWindowFocus: (query) => query.state.status !== 'error',
    retry: false,
    enabled: isAuthenticated,
    ...config,
  });

  return { ...result, currentUser: result.data, isAuthenticated };
};
